var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    fill: "CURRENTCOLOR"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "CURRENTCOLOR",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.751 5.74893C10.751 5.33531 10.4152 5 10.001 5C9.58676 5 9.25098 5.33531 9.25098 5.74893V9.2482H5.75C5.33579 9.2482 5 9.58351 5 9.99713C5 10.4108 5.33579 10.7461 5.75 10.7461H9.25098V14.2511C9.25098 14.6647 9.58676 15 10.001 15C10.4152 15 10.751 14.6647 10.751 14.2511V10.7461H14.25C14.6642 10.7461 15 10.4108 15 9.99713C15 9.58351 14.6642 9.2482 14.25 9.2482H10.751V5.74893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleFilled);
export default __webpack_public_path__ + "static/media/plusCircleFilled.df5e5013.svg";
export { ForwardRef as ReactComponent };